import axios from 'axios';
import Entidad from '@/models/Entidad';
function defaultState() {
	return {
		config: [],
		entidad: [],
		cuit: null,
		vendedores: [],
		entidades: [],
		zonas: [],
		parametros: [,],
	};
}
const state = defaultState();
const getters = {};
const mutations = {
	setConfig(state: { config: object[] }, config: object[]) {
		state.config = config;
	},
	setEntidad(state: { entidad: Entidad[] }, entidad: Entidad[]) {
		state.entidad = entidad;
	},
	setEntidades(state: { entidades: Entidad[] }, entidades: Entidad[]) {
		state.entidades = entidades;
	},
	setVendedores(state: { vendedores: Entidad[] }, vendedores: Entidad[]) {
		state.vendedores = vendedores;
	},
	setZonas(state: { zonas }, zonas) {
		state.zonas = zonas;
	},
	setCuit(state: { cuit: String }, cuit: String) {
		state.cuit = cuit;
	},
	setParametrosModulos(state: { parametros: Object[] }, parametros: Object[]) {
		state.parametros = parametros;
	},
};
const actions = {
	async loadConfig({ commit, dispatch }): Promise<void> {
		const resp = await axios
			.get(`./whitelabel/${this.state.config.cuit}/config.json`)
			.then(response => {
				commit('setConfig', response.data);
				return response.data;
			})
			.catch(() => {
				axios
					.get(`./whitelabel/config.json`)
					.then(response => {
						commit('setConfig', response.data);
						return response.data;
					})
					.catch(() => {
						this.$notify.error({
							title: 'Error',
							message: 'Error al consultar datos del usuario',
							position: 'top-right',
						});
					});
			});
		return resp;
	},

	async callEntities({ commit, dispatch }, query: String): Promise<Entidad[]> {
		const response = await axios.get(`./api/public/proxy/cgi/etenet_entidades?codent=${query}`);
		if (response.data.items) {
			this.entidades = response.data.items;
			return response.data.items;
		}
		return response.data.items;
	},
	async callAllVendedores({ commit, dispatch }, query: String): Promise<Entidad[]> {
		const response = await axios.get(`./api/public/proxy/utils/getAllVendedores`);
		console.log('esta es ', response.data);
		if (response.data.items) commit('setVendedores', response.data.items);
		return response.data.items;
	},
	async callAllEntidades({ commit, dispatch }, query: String): Promise<Entidad[]> {
		const response = await axios.get(`./api/public/proxy/utils/getAllEntidades`);
		if (response.data.items) commit('setEntidades', response.data.items);
		return response.data.items;
	},
	async callAllZonas({ commit, dispatch }, query: String): Promise<Entidad[]> {
		const response = await axios.get(`./api/public/proxy/utils/getAllZonas`);
		if (response.data.items) commit('setZonas', response.data.items);
		return response.data.items;
	},
	saveCuit({ commit, dispatch }, cuit: String) {
		commit('setCuit', cuit);
	},
	async downloadFileDirecto({ commit, dispatch }, params) {
		const response = await axios.get(
			`./api/public/proxy/files?codcom=${params.codcom}&codtal=${params.codtal}&numero=${params.numero}&directa=true`
		);
		if (response.data) return response.data;
	},
	async getParametrosModulos({ commit, dispatch }, data) {
		const response = await axios.get(`./api/public/configuraciones/parametros_modulos`);
		if (response.data) commit('setParametrosModulos', response.data.configuracion);
	},
	reset(): void {
		Object.assign(state, defaultState());
	},
};
export default {
	state,
	getters,
	actions,
	mutations,
};
